const idp: Record<string, string> = {
  新企业注册: 'New Enterprise Registration',
  本操作会将您选择的企业换绑到新的账号下:
    'This operation will rebind the selected enterprise to a new account.',
  组织法人证书: 'Organization Legal Person Certificate',
  请选择所属行业: 'Please select an industry',
  '请输入新的手机号码。更改后，原手机号将不再作为当前账号的登录方式。修改手机号不会修改您在企业中的联系方式':
    'Enter new mobile number. After change, original mobile number will no longer be used as login method for current account. Changing mobile number will not affect your contact information in enterprise.',
  页面未找到: 'Page not found',
  '邀请链接已失效，请联系管理员重新发送有效链接':
    'The invitation link has expired. Please contact the admin to resend a valid link.',
  加入成功: 'Joined successfully',
  服务协议: 'Service Agreement',
  '使用腾讯统一身份登录{name}': 'Use Tencent OneID to log in to {name}',
  提示: 'Notice',
  快速登录: 'Quick Login',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券投资咨询(分析师)。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed. The position is Securities Investment Consultant (Analyst).",
  经营范围: 'Business Scope',
  创建成功: 'Created successfully',
  企业: 'Enterprise',
  注册营养师资格和劳动合同: 'Registered Dietitian Qualification and Employment Contract',
  绑定账号: 'Bind Account',
  '2、请提交结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡':
    '2. Please submit an employment contract with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed.',
  '{start} 至 {end} 有效': 'Valid from {start} to {end}',
  图片剪裁: 'Crop Image',
  '您首次使用手机号登录此账号，请确认是否将此手机号设置为该账号的默认登录手机号。若选择拒绝，将无法通过手机号登录该账号。':
    'This is the first time you log in to this account with the mobile number. Please confirm whether to set this mobile number as the default login mobile number for this account. If you decline, you will not be able to log in to this account via the mobile number.',
  '如"一级播音员主持人"': 'For example, Level-1 Announcer/Host.',
  '{label}简称不能超过15个字符': 'The abbreviation of {label} cannot exceed 15 characters',
  身份证期限信息: 'ID Card Validity Period',
  '您的企业登录密码将在{date}过期，请您尽快更新密码！':
    'Your enterprise login password will expire on {date}. Please update your password as soon as possible.',
  适用于已完成腾讯云实名认证的企业:
    'For enterprises that have completed the Tencent Cloud identity verification',
  总经理: 'General Manager',
  重置密码: 'Reset Password',
  未授权: 'Unauthorized',
  对外展示信息: 'Information Displayed to Public',
  统一社会信用代码格式不正确: 'The unified social credit code format is incorrect',
  请输入用户名: 'Enter username',
  管理: 'Management',
  '如"XX公司基金投资经理"': 'For example, Fund Investment Manager of a specified company.',
  验证码错误: 'Incorrect verification code.',
  忘记密码: 'Forgot Password',
  重置密码成功: 'Password reset successful',
  '{label}简称': '{label} Abbreviation',
  认证审核中: 'Verification under review',
  企业全称: 'Full Enterprise Name',
  '”的登录密码': "'s login password",
  '为保障您的合法权益，请阅读并同意': 'To protect your rights, please read and agree to',
  邮箱验证码登录: 'Email Address Login',
  请输入企业官网链接: 'Enter enterprise official website link',
  '2、请提交药师职业资格证，确保姓名、身份证号、职务、身份证号、证书编号等相关信息清晰可见。':
    '2. Please submit a pharmacist professional qualification certificate, and ensure that the name, ID number, job title, and certificate number are clearly visible.',
  组织法人证书上传范例: 'Organization Legal Person Certificate Upload Example',
  '密码更改成功，请重新登录': 'Password changed. Please log in again.',
  请输入您参加赛事的媒体报道链接: 'Enter media link about event you participated in',
  '3、请提交结束时间大于半年的劳动合同，需盖有单位公章，内容需包含"姓名"、"身份证号"、"入职时间" 和"签署时间"等相关信息。':
    '3. Please submit an employment contract with a remaining term of more than 6 months, stamped with the official seal, including the name, ID number, employment date, and signing date.',
  劳务合同和教师资格证: 'Employment Contract and Teacher Qualification Certificate',
  密码登录: 'Password Login',
  期货从业人员: 'Futures Practitioner',
  '1、请提交由人社或卫生部门及相关技术资格评审会颁发的医师职称证明，需盖有公章，并清晰展示"姓名"、"专业方向"、"资格名称"和"证书编号"等相关信息。':
    '1. Please submit a physician professional title certificate issued by the Ministry of Human Resources and Social Security or health authorities and related technical qualification review committee, stamped with the official seal, clearly showing the name, specialty, qualification name, and certificate number.',
  登录已失效: 'Login expired',
  达人: 'KOL',
  '1、请提交药师职业资格证，确保姓名、身份证号、职务、身份证号、证书编号等相关信息清晰可见。':
    '1. Please submit a pharmacist professional qualification certificate, and ensure that the name, ID number, job title, and certificate number are clearly visible.',
  '2、请提交结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '2. Please submit an employment contract with a remaining term of more than 6 months, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  密码中不可包含登录用户名: 'The password cannot contain the login username',
  媒体: 'Media',
  请稍后重试: 'Please try again later.',
  '验证失败，请稍后重试': 'Verification failed. Please try again later.',
  '该账号已被封禁，请联系管理员': 'The account has been blocked. Please contact the admin.',
  '· 获取你的凭证信息': '· Access your credential information',
  '如"XX达人"': 'For example, KOL of a specified field.',
  认证身份: 'Verification Identity',
  已授权: 'Authorized',
  请尝试编辑短信内容11111发送到10692450或10681483解除运营商黑名单:
    'Please try sending the SMS content "11111" to 10692450 or 10681483 to remove the carrier blocklist restriction.',
  '第一步：点击二维码查看': 'Step 1: Tap the QR code to view',
  请输入经营范围: 'Enter business scope',
  验证码格式不正确: 'Incorrect verification code format',
  邮箱换绑失败: 'Email rebinding failed',
  '恭喜您，认证成功，认证有效期至 {expireDate}。':
    'Congratulations! Verification successful. Valid until {expireDate}.',
  申请审核中: 'Application under review',
  '1、请提交由公办、民办学校开具的，结束时间大于半年的劳务合同，确保姓名、身份证号、学校名称、职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '1. Please submit an employment contract with a remaining term of more than 6 months issued by a public or private school, and ensure that the name, ID number, school name, position, employment date, and official seal are clearly visible and unobstructed.',
  '法定代表/负责人': 'Legal Representative/Person in Charge',
  手持站外后台合影: 'Photo of External Account Admin Screen',
  '如"XX教育机构语文老师"': 'For example, Chinese Teacher of a specified educational institution.',
  '请提交包括但不限于"公开报道链接"、"聘书"、"资格证书"和"职称证明"等能够验证所需认证字段的证明材料。':
    "Please submit supporting materials that can verify your school, professional title, and other verification information, including but not limited to your personal page link on the university's official website and screenshot, appointment letter, and qualification certificates.",
  '作为第一作者，通过主流出版社公开出版的三本以及以上财经类书籍的的图书实体书籍封面页+扉页以及出版证明。':
    'Cover pages, title pages, and proof of publication for three or more finance books publicly published through mainstream publishers as the primary author.',
  是否确认取消授权: 'Are you sure you want to cancel authorization?',
  立即加入: 'Join Now',
  '完成认证可以在已授权的应用中展示您的身份认证标识，凸显职业/达人身份':
    'After the verification, your identity verification logo will be displayed in authorized apps to highlight your professional or KOL identity.',
  手机号码登录: 'Mobile Number Login',
  '您的配置可正常工作但登录失败。根据您设置的匹配逻辑，{identityName}侧该人员无法匹配到系统侧任何人员，在根据未匹配逻辑在系统侧创建该人员时失败。':
    'Your configuration works normally but the login failed. Based on your matching logic, the user on the {identityName} side cannot match any user on the system side, and the user creation on the system side based on the unmatching logic failed.',
  请先进行腾讯云授权认证: 'Please complete the Tencent Cloud authorization verification first',
  请输入目标账号的手机号码: 'Enter target account mobile number',
  '请上传{label}标识': 'Please upload the {label} logo',
  '· 获取你的邮箱': '· Access your email',
  高等学校教师: 'University Teacher',
  我是企业法人: 'I am the enterprise legal person.',
  当前账号权限不足: 'Insufficient account permissions.',
  职业类型: 'Professional Category',
  请输入站外平台链接: 'Enter external platform link',
  请输入主体类型: 'Enter entity type',
  '反面身份证照片更换失败，图片大小超过限制':
    'Failed to replace the back-side ID card photo because the image size exceeds the limit.',
  '创建后您将成为{orgName}管理员，可邀请成员加入，开启高效协作。':
    'After creation, you will become the {orgName} admin and can invite members to join and start efficient collaboration.',
  '如"乒乓球国家队运动员"': 'For example, National Table Tennis Team Athlete.',
  旧密码: 'Old Password',
  '5分钟内有效': 'Valid within 5 minutes',
  '必须包含{content}': 'Must contain {content}.',
  人力资源专员: 'HR Specialist',
  邮箱不可超过64个字符: 'The email cannot exceed 64 characters',
  不同意: 'Disagree',
  '2、请提交由教育部颁发的有效期内教师资格证，需盖有公章，并清晰展示"姓名"、"身份证号"和"证书编号"等相关信息。':
    '2. Please submit a valid teacher qualification certificate issued by the Ministry of Education, stamped with the official seal, clearly showing the name, ID number, and certificate number.',
  解绑成功: 'Unbinding successful',
  长期有效: 'Long-term valid',
  申请人身份证: 'Applicant ID Card',
  结束日期: 'End Date',
  企业微信登录: 'WeCom Login',
  '请上传企业微信对外名片，需包含企业简称、姓名、职务、手机和邮箱。':
    'Please upload your WeCom business card. It must contain the company abbreviation, name, job title, mobile number, and email.',
  '手机号 {mobile}': 'mobile number {mobile}',
  二级以上公共营养师资格和在职证明:
    'Public Nutritionist Qualification and Employment Certificate (Level 2 or Higher)',
  部门: 'Department',
  管理个人版: 'Manage Personal Edition',
  '您未登记手机号码，请联系管理员设置':
    'You have not registered a mobile number. Please contact the admin.',
  '1、请提交3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '1. Please submit an employment certificate issued within 3 months, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  '{clientName}请求你的授权': '{clientName} Requests Your Authorization',
  点击重新扫码: 'Click to Scan Again',
  中进行设置: 'to configure it.',
  复制成功: 'Copied successfully',
  您正在: 'You are using',
  微信扫码完成人脸验证: 'Scan the QR code via WeChat to complete the facial verification.',
  '如"XX公司基金从业人员"': 'For example, Fund Practitioner of a specified company.',
  身份认证: 'Identity Verification',
  申请人实名认证: 'Applicant Identity Verification',
  注册并登录: 'Register and Log In',
  '您可以使用其他账号：': 'You can use another account: ',
  '2、请提交在在国家金融监督管理局备案的保险机构或保险中介机构任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '2. Please submit an employment contract with a remaining term of more than 6 months from an insurance institution or intermediary registered with the National Financial Regulatory Administration, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  请选择达人类型: 'Please select a KOL category.',
  请联系管理员为当前企业开通应用:
    'Please contact the admin to enable the app for the current enterprise.',
  '如需使用，请先绑定您的企业微信账号': 'To use it, please bind your WeCom account first.',
  '收不到验证码？': "Can't receive the verification code?",
  统一社会信用代码: 'Unified Social Credit Code',
  请填写你的姓名: 'Enter your name',
  有效期限: 'Validity Period',
  登录密码: 'Login Password',
  企业执照上传范例: 'Business License Upload Example',
  该操作需要您先设置手机号: 'You need to set a mobile number before performing this operation.',
  该账号已被其他用户占用: 'This account is already used by another user.',
  继续: 'Continue',
  药师: 'Pharmacist',
  'SSO 登录': 'SSO Login',
  请输入申请人姓名: 'Enter applicant name',
  '您可选择以下企业登录，或': 'You can select one of the following enterprises to log in, or',
  请上传营业执照: 'Please upload the business license',
  暂时无法登录: 'Unable to log in for now',
  手机验证码: 'Mobile Phone Verification Code',
  '打开"电子营业执照"微信小程序或APP，并下载执照':
    'Open the Electronic Business License WeChat mini program or app and download the license.',
  '请联系企业法人在"电子营业执照"小程序授权您使用需认证企业的电子营业执照。':
    'Please contact the enterprise legal person to authorize you in the Electronic Business License mini program for the enterprise to be verified.',
  认证数据获取中: 'Obtaining verification data',
  '如"XX职校中级教师"': 'For example, Intermediate Teacher of a specified vocational school.',
  '请联系管理员为当前企业开通应用，或登录其他账号。':
    'Please contact the admin to enable the app for the current enterprise, or log in with another account.',
  '请先使用手机号登录腾讯会议客户端，前往【账号与安全】统一绑定登录方式':
    'Please first log in to Tencent Meeting with your mobile number, and then go to Account & Security to unify login bindings.',
  '请提供能够证明本人达人身份的资料，包括但不限于本人获奖证书、新闻相关报道、原创的创作资料、版权证明或创作过程证明等材料。':
    'Please provide materials that can prove your KOL identity, including but not limited to award certificates, news reports, original creative materials, copyright proof, or proof of the creation process.',
  '如"律师"': 'For example, Lawyer.',
  其他职称证明: 'Other Professional Title Certificates',
  获奖证明: 'Award Certificates',
  注册资本: 'Registered Capital',
  '如无法提供在职证明，请提交就职医院官网截图，清晰展示姓名、单位、个人头像、所处科室和职称等相关信息。':
    "If you cannot provide an employment certificate, please submit a screenshot from your hospital's official website, which clearly shows the name, institution, personal photo, department, and professional title.",
  '该企业暂未配置 SSO 登录方式，如需使用 SSO 登录，请联系管理员。':
    'SSO login is not configured for this enterprise yet. Please contact the admin if you need it.',
  没有权限: 'No permission',
  金融分析师: 'Financial Analyst',
  保险从业者: 'Insurance Practitioner',
  '如"XX公司高级会计师"': 'For example, Senior Accountant of a specified company.',
  '如"XX医院营养师"': 'For example, Nutritionist of a specified hospital.',
  '该账号已被删除，请更换手机号后再试':
    'The account has been deleted. Please try another mobile number.',
  '管理员更新了密码策略，请您重新设置密码':
    'The admin has updated the password policy. Please set your password again.',
  创建企业: 'Create Enterprise',
  '如：教师、医生、律师等': 'For example, teacher, doctor, lawyer, etc.',
  '您正在将企业：{tenantName} 绑定至其他账号，请先完成身份验证':
    'You are rebinding the enterprise {tenantName} to another account. Please complete the identity verification first.',
  '是否确认解除绑定{type}': 'Are you sure you want to unbind {type}?',
  '如：XX公司HRBP': 'For example, HRBP of a specified company.',
  免费注册: 'Free Registration',
  我的账号: 'My Account',
  请上传组织法人证明: 'Please upload the organization legal person proof',
  认证失效: 'Verification invalidated',
  '3、请提交由医疗机构3个月内开具的，有效期内的在职证明，确保姓名、身份证号、职称、所在科室、入职时间和公章等信息清晰可见。':
    '3. Please submit an employment certificate issued by a medical institution within 3 months, and ensure that the name, ID number, professional title, department, employment date, and official seal are clearly visible.',
  '《腾讯统一身份认证服务协议》': 'Tencent OneID Verification Service Agreement',
  '邮箱 {email}': 'Email {email}',
  '检测到匹配用户已被停用，登录失败！有问题请联系企业管理员。':
    'The matched user has been disabled. Login failed. Please contact the enterprise admin.',
  退出企业: 'Leave Enterprise',
  中等职业学校教师: 'Vocational School Teacher',
  '如需使用其他验证方式，请联系管理员添加手机号/邮箱。':
    'To use other verification methods, please contact the admin to add a mobile number or email.',
  '2、请提交在3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '2. Please submit an employment certificate issued within 3 months, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  查看范例: 'View Example',
  '请联系管理员为您重新启用。您也可选择以下企业登录。':
    'Please contact the admin to re-enable your account. You can also select one of the following enterprises to log in.',
  联系法人授权您使用电子营业执照:
    'Contact the legal person to authorize your use of the electronic business license.',
  您已拒绝使用手机号登录: 'You have declined to log in with the mobile number',
  '如"基金经理"': 'For example, Fund Manager.',
  企业授权函认证: 'Enterprise Authorization Letter Verification',
  必须包含特殊符号: 'Must contain special characters.',
  最多不超过15个字: 'Up to 15 characters',
  录入人脸核身信息: 'Enter facial verification information',
  文件大小超出限制: 'The file size exceeds the limit.',
  '请提交包括但不限于"获奖证明"、"荣誉证明"、"聘书"、"参演证明"和"职称证明"等能够验证职位、任职单位、任职时间的证明材料。':
    'Please submit supporting materials that can verify your position, employer, and employment period, including but not limited to award certificates, honor certificates, appointment letters, performance certificates, and professional title certificates.',
  请输入证件号码: 'Enter ID number',
  操作成功: 'Operation successful',
  会计师: 'Accountant',
  当前企业暂未开通应用: 'No apps enabled for the enterprise',
  '如"XX公司期货从业人员"': 'For example, Futures Practitioner of a specified company.',
  账号密码登录: 'Username and Password Login',
  请输入注册资本: 'Enter registered capital',
  '手机号已注册，请登录': 'The mobile number is already registered. Please log in.',
  '您的原密码已经失效，请设置新的密码。':
    'Your original password has been invalidated. Please set a new password.',
  请确认新密码: 'Please confirm your new password',
  '创建后，您将成为管理员，可邀请成员。':
    'After creation, you will become the admin and can invite members.',
  请输入组织全称: 'Enter full organization name',
  '认证类型为：{jobType}。认证有效期至 {expireDate}。':
    'Verification type: {jobType}. Valid until {expireDate}.',
  '如"XX公司房产客户经理"': 'For example, Real Estate Account Manager of a specified company.',
  '3、请提交在3个月内由相关房产机构开具的可证明认证单位和职位属实的在职证明，需盖有单位公章，内容需包含"姓名"、"身份证号"、"入职时间" 和"签署时间"等相关信息。':
    '3. Please submit an employment certificate issued within 3 months by a relevant real estate institution, verifying your employer and position, stamped with the official seal, including the name, ID number, employment date, and signing date.',
  上传授权函: 'Upload Authorization Letter',
  '请提交包括但不限于"在职证明"、"劳务合同"等具备公章，且能够证明在职公司、目前职位、在职时效、以及其他认证信息的证明材料。':
    'Please submit supporting materials that are stamped with the official seal and can verify your current employer, position, employment period, and other verification information, including but not limited to an employment certificate and employment contract.',
  执业资格证和在职证明: 'Professional Qualification and Employment Certificate',
  下一步: 'Next',
  确定: 'Confirm',
  组织机构: 'Organization',
  '如：赛事选手、娱乐达人等': 'For example, event participant, entertainment KOL, etc.',
  解绑账号: 'Unbind Account',
  登录用户名: 'Login Username',
  '· 企业认证状态发生的变更': '· Changes to enterprise verification status',
  '微信扫描下方二维码，选择需认证企业的电子营业执照，输入执照密码后，点击"确认登录"，等待认证成功结果即可。电子营业执照具体使用说明您可参考':
    'Scan the QR code below with WeChat, select the electronic business license for the enterprise to be verified, enter the license password, tap Confirm Login, and wait for the verification result. For detailed usage instructions, please refer to: ',
  我不是企业法人: 'I am not the enterprise legal person.',
  邮箱: 'Email',
  对外信息展示: 'Information Displayed to Public',
  请先发送验证码: 'Please send the verification code first',
  '2、请提交在在国家金融监督管理局备案的保险机构或保险中介机构任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '2. Please submit an employment certificate issued within 3 months by an insurance institution or intermediary registered with the National Financial Regulatory Administration, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  刷新审核结果: 'Refresh Review Result',
  上传企业标识: 'Upload Enterprise Logo',
  拒绝邀请: 'Decline Invitation',
  '请提交有效期内的由电视台、广播台等媒体机构在职证明/劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。其中在职证明需在3个月内开具，劳务合同有效期需大于半年。':
    'Please submit a valid employment certificate or employment contract issued by a TV station, radio station, or other media institution, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The employment certificate must be issued within 3 months, and the employment contract must have a remaining term of more than 6 months.',
  '您创建的{orgName}已达上限': 'The number of {orgName} you created has reached the limit.',
  '您首次使用邮箱登录此账号，请确认是否将此邮箱设置为该账号的默认登录邮箱。若选择拒绝，将无法通过邮箱登录该账号。':
    'This is the first time you log in to this account with the email. Please confirm whether to set this email as the default login email for this account. If you decline, you will not be able to log in to this account via the email.',
  输入密码: 'Enter Password',
  '请提交有效期内的在职证明/劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。其中 在职证明 需在3个月内开具，劳务合同有效期需大于半年。':
    'Please submit a valid employment certificate or employment contract, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The employment certificate must be issued within 3 months, and the employment contract must have a remaining term of more than 6 months.',
  赛事选手: 'Event Participant',
  个人资质截图和劳动合同: 'Personal Qualification Screenshot and Employment Contract',
  确认密码: 'Confirm Password',
  登录: 'Log In',
  '请联系管理员为您分配{appName}许可':
    'Please contact the admin to assign a license of {appName} to you.',
  暂不支持此类手机号: 'This type of mobile number is not supported',
  腾讯会议: 'Tencent Meeting',
  暂不取消: 'Later',
  个人中心: 'Personal Center',
  '当前未认证，仅为预览效果': 'Not yet verified. Preview only.',
  证券投资经理: 'Securities Investment Manager',
  '请输入您的密码。': 'Enter your password',
  创建人姓名: 'Creator Name',
  请上传授权函: 'Please upload the authorization letter',
  '请输入您的密码。该密码将用于在{companyName}中的登录。':
    'Enter your password. This password will be used for login in {companyName}.',
  '如"总监"': 'For example, Director.',
  修改认证: 'Modify Verification',
  '1、请提交由中国房地产估价师与房地产经纪人学会颁布的有效期内的国家房地产经纪专业人员职业资格证，需盖有公章，并清晰展示"姓名"、"证件号码"和"管理号"等相关信息。':
    '1. Please submit a valid National Real Estate Brokerage Professional Qualification Certificate issued by the China Institute of Real Estate Appraisers and Agents, stamped with the official seal, clearly showing the name, ID number, and registration number.',
  请设置密码: 'Please set a password.',
  '您可选择以下企业登录{appName}，或':
    'You can select one of the following enterprises to log in to {appName}, or',
  '您正在修改手机号码，请先完成身份验证':
    'You are changing the mobile number. Please complete the identity verification first.',
  '请联系管理员为您分配{appName}许可，或登录其他账号。':
    'Please contact the admin to assign a license of {appName} to you, or log in with another account.',
  站外平台链接: 'External Platform Link',
  服务协议与隐私政策: 'Service Agreement and Privacy Policy',
  '您的官方认证已过期，可选择重新发起认证。':
    'Your official verification has expired. You can re-initiate verification.',
  扫码成功: 'Scanning successful',
  团队: 'Team',
  '(本人为法人) 公司营业执照/事业单位法人证明':
    '(Self as Legal Person) Company Business License/Public Institution Legal Person Certificate',
  组织全称: 'Full Organization Name',
  '· 获取你的账号头像、昵称信息': '· Access your account avatar and nickname',
  '申请资料审核预计 5～10 个工作日内出结果，认证结果将发送至收件箱，请注意查收。':
    'The submitted materials are expected to be reviewed within 5 to 10 working days. The result will be sent to your inbox.',
  密码设置失败: 'Failed to set the password.',
  '如"XX电台一级播音员主持人"': 'For example, Level-1 Announcer/Host of a specified station.',
  '对不起，您的认证已失效，失效原因：{reason}，您可选择重新发起认证。':
    'Sorry, your verification is no longer valid. Reason: {reason}. You can re-initiate verification.',
  暂不解绑: 'Later',
  '自 {start} 起长期有效': 'Valid from {start} for a long term',
  密码修改成功: 'Password changed successfully',
  验证码已发送至: 'The verification code is sent to',
  房地产经纪人: 'Real Estate Agent',
  切换其他企业账号: 'Switch to Another Enterprise Account',
  未找到匹配的企业: 'No matching enterprise found',
  钉钉: 'DingTalk',
  基金从业人员: 'Fund Practitioner',
  请重试或联系管理员: 'Please retry or contact the admin.',
  '在企业微信移动端 APP 中打开个人中心，点击右上方 ① “二维码图标”查看对外名片。':
    'In the WeCom mobile app, open the personal center and tap ① the QR code icon in the upper right corner to view the business card.',
  '手机号已被别的账号绑定，绑定失败': 'The mobile number is already bound to another account.',
  业务: 'Business',
  '人员创建失败。您的手机号与企业内成员重复，请联系管理员。':
    'Failed to create the user. Your mobile number conflicts with that of an existing enterprise member. Please contact the admin.',
  需联系企业超级管理员开通应用:
    'Please contact the enterprise super administrator to enable the application',
  手机号修改成功: 'Mobile number changed successfully',
  入职时间: 'Employment Date',
  重置: 'Reset',
  验证码登录: 'Verification Code Login',
  '取消授权后，腾讯会议将不能获取您的认证信息，但不影响您的认证审核过程和认证状态。':
    'After authorization is canceled, Tencent Meeting will no longer be able to access your verification information, but this will not affect your verification review process or verification status.',
  头像: 'Avatar',
  验证码不能为空: 'The verification code cannot be empty',
  请输入统一社会信用代码: 'Enter unified social credit code',
  当前链接已失效: 'The current link has expired.',
  选择账号: 'Select Account',
  认证身份类型: 'Verification Identity Type',
  适用于已申请电子营业执照的企业:
    'For enterprises that have applied for electronic business licenses',
  补充证明材料: 'Additional Supporting Materials',
  '不支持类型{type}的文件': 'Files of the {type} type are not supported.',
  个人资质截图和在职证明: 'Personal Qualification Screenshot and Employment Certificate',
  新建个人账号: 'Create Personal Account',
  '如"开发工程师"': 'For example, Development Engineer.',
  注册方式: 'Registration Method',
  '如"保险销售经理"': 'For example, Insurance Sales Manager.',
  '第二步：检查字段与保存': 'Step 2: Check fields and save',
  实名认证: 'Identity Verification',
  '如"中级教师"': 'For example, Intermediate Teacher.',
  图片格式错误: 'Incorrect image format.',
  '登录渠道尚未开通，请联系管理员':
    'The login channel is not enabled yet. Please contact the admin.',
  '如"证券投资经理"': 'For example, Securities Investment Manager.',
  '请选择清晰的扫描件或照片，保障图片内容无遮挡或过曝，生成的信息更准确。':
    'Please select a clear scan or photo and ensure that the image content is not obscured or overexposed for more accurate results.',
  更换: 'Change',
  '如"会计师"': 'For example, Accountant.',
  '您正在重置登录密码，请先完成身份验证':
    'You are resetting your login password. Please complete the identity verification first.',
  '请联系管理员为您分配应用许可，或登录其他账号。':
    'Please contact the admin to assign an app license to you, or log in with another account.',
  前往腾讯云认证: 'Go to Tencent Cloud for Verification',
  从业人员资质截图和劳动合同: 'Practitioner Qualification Screenshot and Employment Contract',
  '如"XX律所律师"': 'For example, Lawyer of a specified law firm.',
  'IT/互联网': 'IT/Internet',
  '解绑后，您将无法使用手机号 {mobile} 登录以下 {count} 个账号。':
    'After unbinding, you will no longer be able to use the mobile number {mobile} to log in to the following {count} account(s).',
  修改名称: 'Edit Name',
  上传失败: 'Upload failed',
  '· 您的手机号和邮箱': '· Your mobile number and email',
  站外平台认证: 'External Platform Verification',
  手机号修改失败: 'Failed to change the mobile number.',
  大写字母: 'Uppercase letters',
  重新登录: 'Log In Again',
  开通应用失败: 'Failed to enable the app.',
  取消授权: 'Cancel Authorization',
  短信将发送至您绑定: 'The SMS will be sent to your bound',
  '如"XX公司就业咨询顾问"': 'For example, Career Consultant of a specified company.',
  '您的配置可正常工作但登录失败。根据您设置的匹配逻辑，{identityName}侧该人员无法匹配到系统侧任何人员，根据未匹配逻辑被拒绝登录。':
    'Your configuration works normally but the login failed. Based on your matching logic, the user on the {identityName} side cannot match any user on the system side, and the login is rejected based on the unmatching logic.',
  '您当前的企业身份暂未绑定账号，请您先进行绑定':
    'Your current enterprise identity is not bound to an account yet. Please bind first.',
  '请提交包括但不限于高校官网个人主页链接及截图、"聘书"、"资格证书"等能够认证在职学校、职称以及其他认证信息的证明材料。':
    "Please submit supporting materials that can verify your school, professional title, and other verification information, including but not limited to your personal page link on the university's official website and screenshot, appointment letter, and qualification certificates.",
  '· 您的企业认证信息': '· Your enterprise verification information',
  请输入短信验证码: 'Enter SMS verification code',
  成立日期: 'Date of Establishment',
  '请提交包括但不限于"在职证明"、"劳务合同"等具备公章，能够证明在职学校、职称以及其他认证信息的证明材料。':
    'Please submit supporting materials that are stamped with the official seal and can verify your school, professional title, and other verification information, including but not limited to an employment certificate and employment contract.',
  '请提交有效期内的在职证明/劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和公章等信息清晰可见、无遮挡。其中在职证明需在3个月内开具，劳务合同有效期需大于半年。':
    'Please submit a valid employment certificate or employment contract, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The employment certificate must be issued within 3 months, and the employment contract must have a remaining term of more than 6 months.',
  重新选择: 'Reselect',
  验证身份: 'Verify Identity',
  请检查短信是否归类到垃圾通知:
    'Please check whether the SMS was categorized as spam notifications.',
  '最多上传 {limitNum} 张，支持 jpg/png 格式，大小在 5M 以内。':
    'You can upload up to {limitNum} images. Supported formats are JPG and PNG, with a maximum file size of 5 MB.',
  '在职证明/劳动合同': 'Employment Certificate/Employment Contract',
  '文件{name}大于5M，请重新选择': 'The file {name} exceeds 5 MB. Please reselect.',
  '用户名或密码错误，登录失败。': 'Incorrect username or password. Login failed.',
  请验证当前手机号: 'Please verify the current mobile number.',
  '1、请提交由具备办学许可证的合法教育培训机构开具的，结束时间大于半年的劳务合同，确保姓名、身份证号、学校名称、职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '1. Please submit an employment contract with a remaining term of more than 6 months issued by a legally licensed educational institution, and ensure that the name, ID number, school name, position, employment date, and official seal are clearly visible and unobstructed.',
  '请提交由正规部门或测评中心颁发的主持人/播音相关职称证明，需盖有公章，并清晰展示"姓名"、"专业方向"、"资格级别"和"证书编号"等相关信息。':
    'Please submit a host/broadcasting professional title certificate issued by a recognized department or evaluation center, stamped with the official seal, clearly showing the name, specialty, qualification level, and certificate number.',
  营养师: 'Nutritionist',
  '登录失败，请稍后重试': 'Login failed. Please try again later.',
  用户未注册: 'User not registered',
  请输入企业域名: 'Domain',
  '{type}绑定失败': 'Failed to bind {type}.',
  今日验证码发送次数已达上限: 'The daily limit for sending verification codes has been reached.',
  目标账号手机号: 'Target Account Mobile Number',
  请输入创建人姓名: 'Enter creator name',
  '如"XX职校语文老师"': 'For example, Chinese teacher of a specified vocational school.',
  '密码错误，请重新输入': 'Incorrect password. Please re-enter.',
  返回: 'Back',
  在职证明和教师资格证: 'Employment Certificate and Teacher Qualification Certificate',
  '1、请提交注册会计师资格证书，清晰展示"姓名"、"专业方向"、"资格级别"和"管理号"等相关信息。':
    '1. Please submit a CPA qualification certificate, clearly showing the name, specialty, qualification level, and registration number.',
  密码验证: 'Password Verification',
  姓名: 'Name',
  请输入地址: 'Enter address',
  申请人姓名: 'Applicant Name',
  资格证证明: 'Professional Certificate',
  '职称证明、电子执照、在职证明':
    'Professional Title Certificate, Electronic License, and Employment Certificate',
  加入企业成功: 'Joined the enterprise successfully',
  点击重新授权: 'Click to Re-authorize',
  刷新中: 'Refreshing',
  取消: 'Cancel',
  企业标识: 'Enterprise Identifier',
  暂未授权: 'Not yet authorized',
  企业域名: 'Enterprise Domain',
  '密码重置成功，请重新登录': 'Password reset successfully. Please log in again.',
  '需联系企业超级管理员开通{appName}':
    'Please contact the enterprise super admin to activate {appName}.',
  腾讯统一身份: 'Tencent OneID',
  '如"基金投资经理"': 'For example, Fund Investment Manager.',
  名称不可超过64字符: 'The name cannot exceed 64 characters',
  请输入认证身份: 'Enter verification identity',
  预览: 'Preview',
  '如"设计师"': 'For example, Designer.',
  提交审核: 'Submit for Review',
  您暂未加入当前企业: 'You have not joined the current enterprise yet.',
  中小学教师: 'Primary or Secondary School Teacher',
  '如"产品经理"': 'For example, Product Manager.',
  '如"金融分析师"': 'For example, Financial Analyst.',
  解绑: 'Unbind',
  暂不设置: 'Later',
  '拒绝后如需重新加入，需联系管理员再次邀请，请谨慎操作':
    'If you want to join again after declining, you need to contact the admin to re-invite you. Please proceed with caution.',
  确认新密码: 'Confirm New Password',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位需为基金投资经理。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The position must be Fund Investment Manager.",
  '如"前线记者"': 'For example, Frontline Reporter.',
  '您的配置可正常工作且登录成功。根据您设置的匹配逻辑{identityName}侧该人员匹配到了系统侧某人员，或根据未匹配逻辑被创建。':
    'Your configuration works normally and the login is successful. Based on your matching logic, the user on the {identityName} side matches a user on the system side, or is created based on the unmatching logic.',
  执业资格证和登记备案截图: 'Professional Qualification Certificate and Registration Screenshot',
  请先获取验证码: 'Please send the verification code first',
  身份证上传范例: 'ID Card Upload Example',
  授权成功: 'Authorization successful',
  '将获取以下权限：': 'The following permissions will be requested: ',
  '{orgName}名称': '{orgName} Name',
  个人: 'Personal',
  '请联系管理员为您重新启用。或登录其他账号。':
    'Please contact the admin to re-enable your account or log in with another account.',
  撤回认证: 'Withdraw Verification',
  '您的登录密码已过期，请重置密码': 'Your login password has expired. Please reset it.',
  '你将使用以下账号授权登录：': 'You will authorize the login with the account: ',
  '人员创建失败。您的登录用户名与企业内成员重复，请联系管理员。':
    'Failed to create the user. Your login username conflicts with that of an existing enterprise member. Please contact the admin.',
  更换密码: 'Change Password',
  账号登录方式: 'Account Login Method',
  '为保障账号安全，当前账号需重置密码后使用':
    'To ensure account security, this account requires a password reset before use.',
  '1、请提交结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '1. Please submit an employment contract with a remaining term of more than 6 months, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  '您已加入，无需重复加入': 'You have already joined and do not need to join again.',
  '如"大数据挖掘"': 'For example, Big Data Mining.',
  医生: 'Doctor',
  适用于不便使用电子营业执照的企业:
    'For enterprises that cannot conveniently use electronic business licenses',
  '如"XX公司产品经理"': 'For example, Product Manager of a specified company.',
  '· 获取你的手机号': '· Access your mobile number',
  '图片更新失败，图片大小超过限制':
    'Failed to update the image because the image size exceeds the limit.',
  '拒绝后如需重新加入，需联系管理员再次邀请。':
    'If you want to join again after declining, you need to contact the admin to re-invite you.',
  注册地址: 'Registered Address',
  '加入失败，请重试': 'Failed to join. Please try again.',
  '省市级及以上的获奖证书/奖杯/奖牌和奖项相关主流媒体报道链接。材料需体现获奖年份、赛事名称、获奖名次、真实姓名、证书颁发时间等信息，链接需体现赛事名称、获奖信息、真实姓名等信息。':
    'Provincial/municipal-level or higher award certificates/trophies/medals and links to mainstream media coverage of the awards. The materials must include the award year, event name, placement, real name, and certificate issuance date. The links must include the event name, award information, and real name.',
  安全验证: 'Security Verification',
  暂未绑定手机号: 'No mobile number bound',
  '服务器出现了问题，请刷新后重试': 'Server error. Please refresh and try again.',
  '如"XX公司设计师"': 'For example, Designer of a specified company.',
  请选择: 'Please select',
  使用其他账号: 'Switch Account',
  '请下载授权函模版，完成信息填写后加盖{label}彩色公章，以彩色扫描件或照片的形式上传。':
    'Please download the authorization letter template, complete the information, stamp with the official seal in color of {label}, and upload it as a color scan or photo.',
  您已拒绝授权登录: 'You have declined the authorization request.',
  '保证证件完整、清晰、无反光，避免任何文字或图案被遮挡。':
    'Ensure that the certificate is complete, clear, and glare-free, with no text or images obscured.',
  主体类型: 'Entity Type',
  拒绝: 'Decline',
  签发机关: 'Issuing Authority',
  登录成功: 'Login successful',
  会中展示认证信息: 'Display verification info during meetings',
  职业: 'Professional',
  暂无登录用户名: 'No login username yet',
  主持人: 'Host',
  '若您收不到验证码，请确认是否存在以下状况：':
    'If you cannot receive the verification code, please check the following: ',
  '如"主管药师"': 'For example, Supervising Pharmacist.',
  恢复默认: 'Restore Default',
  组织: 'Organization',
  邮箱格式不正确: 'Incorrect email format',
  请上传手持站外后台合影:
    "Please upload a photo of the verifier holding the external platform account's admin screen.",
  工号: 'Employee ID',
  '请联系管理员为您重新启用或登录其他账号。':
    'Please contact the admin to re-enable your account or log in with another account.',
  '邀请码是一个由字母和数字组成的 8 位编码，可通过管理员获取。':
    'The invitation code is an 8-character code consisting of letters and digits. You can obtain it from the admin.',
  地址: 'Address',
  完成: 'Finish',
  绑定失败: 'Binding failed',
  职称: 'Professional Title',
  飞书: 'Lark',
  '检测您的配置有误，请根据': 'Your configuration is incorrect. Please refer to',
  企微身份认证: 'WeCom Identity Verification',
  '如"XX公司会计师"': 'For example, Accountant of a specified company.',
  '职称证明、执业资格证、在职证明':
    'Professional Title Certificate, Professional Qualification Certificate, and Employment Certificate',
  '应用将获得您的以下信息并用于对外展示：':
    'The app will obtain the following information for external display: ',
  用户名密码: 'Password Login',
  '执业资格证、登记备案截图、在职证明':
    'Professional Qualification Certificate, Registration Screenshot, and Employment Certificate',
  '若您使用双卡双待手机，请检查AB卡是否正确安放（可尝试更换AB卡位置）':
    'If you are using a dual-SIM mobile phone, please check whether SIM cards A and B are inserted correctly. You can also try swapping their positions.',
  该用户目前没有日志: 'This user currently has no logs.',
  请填写验证码: 'Enter verification code',
  '如"总经理"': 'For example, General Manager.',
  密码设置成功: 'Password set successfully',
  上传营业执照: 'Upload Business License',
  短信将发送至您企微绑定: 'The SMS will be sent to your WeCom-bound',
  '{prefix}密码': '{prefix} password',
  '· 企业/组织标识和简称': '· Enterprise/organization logo and abbreviation',
  个人版管理: 'Personal Edition Management',
  密码重置失败: 'Failed to reset the password.',
  '将向您在企业内登记的手机号/邮箱发送验证码，如未登记手机号/邮箱，请联系企业管理员重置密码。':
    'A verification code will be sent to the mobile number/email registered in your enterprise. If no mobile number/email is registered, please contact the enterprise admin to reset your password.',
  '该用户名匹配到多个用户，请使用 UserPrincipalName 或 sAMAccountName 作为用户名进行登录。':
    'This username matches multiple users. Please use UserPrincipalName or sAMAccountName to log in.',
  '支持 JPG/JPEG/PNG 格式，文件大小在 5M 以内。':
    'Supports JPG/JPEG/PNG formats, with a file size limit of 5 MB.',
  '2、请提交当地住建委或住建局或房屋管理局或全国房地产经纪行业平台完成登记备案的房地产经纪人登记备案截图。需清晰展示"个人信息"、"证书管理号"和"专业类别"。':
    '2. Please submit a screenshot of the real estate agent registration filed with the local Housing and Urban-Rural Development Commission, Housing and Construction Bureau, Housing Management Bureau, or the National Real Estate Brokerage Platform. It must clearly show the personal information, certificate registration number, and professional category.',
  仅展示30天内的日志记录: 'Only logs from the past 30 days are displayed.',
  '目标账号个人版注销未满15天，无法换绑':
    'The target personal edition account has been canceled for less than 15 days and cannot be rebound.',
  请在: 'Please go to',
  '验证码错误，请重新输入': 'Incorrect verification code. Please re-enter.',
  '还没有账号，': "Don't have an account yet? ",
  新的手机号: 'New Mobile Number',
  '请提交国家二级/三级心理咨询师证，包括个人照片页与个人信息页，彩色原件，证件信息清晰。':
    'Please submit a national level-2/level-3 psychological counselor certificate, including the personal photo page and information page, original in color, with clear certificate details.',
  咨询顾问: 'Consultant',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券经纪人。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The position is Securities Broker.",
  修改密码: 'Change Password',
  选择登录账号: 'Select a login account',
  '忘记密码？': 'Forgot password?',
  '在职证明/劳务合同': 'Employment Certificate/Employment Contract',
  请输入姓名: 'Enter name',
  手机号: 'Phone',
  '您正在设置登录密码，请先完成身份验证':
    'You are setting your login password. Please complete the identity verification first.',
  请输入法定代表人: 'Enter legal representative',
  请输入旧密码: 'Enter old password',
  '。': '.',
  已拒绝: 'Declined',
  艺术达人: 'Art KOL',
  前往使用: 'Go to Use',
  '如"CTO"': 'For example, CTO.',
  企业和职位: 'Enterprise and Position',
  用户名或密码输入有误: 'The username or password is incorrect.',
  '该手机号已加入，无需重复申请': 'This mobile number has already joined. No need to apply again.',
  '请上传图片证明账号归属权：认证人手持站外后台合影。':
    "Please upload an image to verify the account ownership: a photo of the verifier holding the external platform account's admin screen.",
  修改: 'Modify',
  '验证码不正确，请重新输入': 'Incorrect verification code. Please re-enter.',
  请输入您在企业内的登录用户名: 'Enter your login username',
  '仅支持5M以内的jpg/ jpeg/ png/ gif 文件':
    'Only JPG/JPEG/PNG/GIF files within 5 MB are supported.',
  请为您的邮箱设置登录密码: 'Please set a login password for your email.',
  确认恢复: 'Confirm Restore',
  请上传企微名片: 'Please upload your WeCom business card',
  '验证码错误，请重新填写': 'Incorrect verification code. Please re-enter.',
  '您没有“{name}”的使用权限': 'You do not have the permission to use {name}.',
  手机验证码登录: 'Phone Number Login',
  邀请你加入: 'Join',
  '请提交注册会计师资格证书，清晰展示"姓名"、"专业方向"、"资格级别"和"管理号"等相关信息。':
    'Please submit a CPA qualification certificate, clearly showing the name, specialty, qualification level, and registration number.',
  '支持 jpg/png 格式，大小在 5M 以内。': 'Supports JPG/PNG formats, up to 5 MB in size.',
  '上传{label}标识': 'Upload {label} Logo',
  教育: 'Education',
  '您已录入成功，将为您跳转至管理后台。':
    'Your entry has been successfully recorded. You will now be redirected to the admin console.',
  '当前企业内已存在相同的手机号码，请更换后重试':
    'The same mobile number already exists in the current enterprise. Please try another one.',
  '{name} 万元': '{name}0,000 CNY',
  公司全称: 'Full Company Name',
  '微信扫描右侧小程序二维码进入"电子营业执照"微信小程序。或直接进入APP，点击"下载执照"，下载需认证企业的电子营业执照。':
    'Scan the QR code on the right with WeChat to open the Electronic Business License mini program, or open the app directly, tap Download License, and download the electronic business license of the enterprise to be verified.',
  '请输入{label}简称，并确保简称唯一不重复':
    'Enter {label} abbreviation and ensure that it is unique',
  数据工程师: 'Data Engineer',
  '如"XX公司大数据挖掘"': 'For example, Big Data Mining of a specified company.',
  身份验证: 'Identity verification',
  重新发送: 'Resend',
  手机号验证: 'Mobile Number Verification',
  适用于非企业性质的法人组织: 'For non-enterprise legal person organizations',
  '如"XX医院内科主任"': 'For example, Chief of Internal Medicine of a specified hospital.',
  确认邮箱成功: 'Email confirmed',
  已加入企业: 'Joined Enterprises',
  更多方式: 'More',
  请检查手机是否欠费: 'Please check whether your mobile phone account has overdue charges.',
  请选择职业类型: 'Please select a professional category.',
  授权同步认证信息: 'Authorize Sync of Verification Information',
  监管系统截图和劳动合同: 'Regulatory System Screenshot and Employment Contract',
  更换手机号不会修改您在组织中的联系方式:
    'Changing the mobile number will not affect your contact information in the organization.',
  '请提交由正规专业技术资格协会颁发的会计师职称证明，需盖有公章，并清晰展示"姓名"、"专业方向"、"资格级别"和"管理号"等相关信息。':
    'Please submit an accountant professional title certificate issued by a recognized professional technical qualification association, stamped with the official seal, clearly showing the name, specialty, qualification level, and registration number.',
  '1、请提交由国家政务服务平台查询保险从业人员查询出的个人资质截图，需清晰展示"姓名"、"执业机构"、"执业岗位"和"登记编号"，链接：https://cbirc.gjzwfw.gov.cn/。':
    '1. Please submit a screenshot of your personal qualification queried from the National Government Services Platform for insurance practitioners, clearly showing the name, practicing institution, position, and registration number. Link: https://cbirc.gjzwfw.gov.cn/.',
  请填写签发机关: 'Enter issuing authority',
  暂未设置: 'Not set',
  用户名长度不能超过64个字符: 'The username cannot exceed 64 characters',
  请输入企业名称: 'Enter enterprise name',
  个人名片展示认证信息: 'Display verification info on personal business card',
  '人员创建失败。邮箱与企业内成员重复，请联系管理员。':
    'Failed to create the user. The email conflicts with that of an existing enterprise member. Please contact the admin.',
  劳务合同和公司营业执照: 'Employment Contract and Company Business License',
  注册会计师证明: 'CPA Certificate',
  请输入正确的网址: 'Enter a valid URL',
  未绑定: 'Not bound',
  记者: 'Journalist',
  当前企业: 'Current Enterprise',
  '请提交由国家新闻出版广电总局或国家新闻出版署颁发的有效期内新闻记者证，需盖有公章，并清晰展示"姓名"、"身份证号"和"统一编号"等相关信息。':
    'Please submit a valid press card issued by the State Administration of Press, Publication, Radio, Film and Television, or the National Press and Publication Administration, stamped with the official seal, clearly showing the name, ID number, and unified number.',
  '重新发送({time})': 'Resend ({time})',
  '如"XX高校中级教师"': 'For example, Intermediate Teacher of a specified university.',
  '该手机号在“{name}”下账号已被停用，请联系管理员':
    'The account under {name} for this mobile number has been disabled. Please contact the admin.',
  手机号码: 'Mobile Number',
  跳过: 'Skip',
  '您已拒绝管理员的“{name}”加入邀请，如需重新加入，请联系管理员再次邀请。':
    "You have declined the admin's invitation to join {name}. If you want to join again, please ask the admin to invite you again.",
  '上传中...': 'Uploading...',
  授权函: 'Authorization Letter',
  '如"王者荣耀大神"': 'For example, KOL of Honor of Kings.',
  '已加入企业（{count}）': 'Joined Enterprises ({count})',
  '请联系管理员为您加入当前企业。您也可选择以下企业登录。':
    'Please contact the admin to add you to the current enterprise. You can also select one of the following enterprises to log in.',
  电子营业执照: 'Electronic Business License',
  '1、请提交中国证券业协会官网信息公示中个人资质截图，需清晰展示"姓名"、"执业机构"、"执业岗位"和"登记编号"，链接：https://www.sac.net.cn。':
    '1. Please submit a screenshot of your personal qualification from the website of the Securities Association of China, clearly showing the name, practicing institution, position, and registration number. Link: https://www.sac.net.cn.',
  企业版: 'Enterprise Edition',
  '对不起，您的{orgType}认证审核未通过，未通过原因：{reason}，您可选择重新发起认证。':
    'Sorry, your {orgType} verification has not passed. Reason: {reason}. You can choose to re-initiate the verification.',
  赛事: 'Event',
  本企业: 'this enterprise',
  授权并前往认证: 'Authorize and Verify',
  '手机收件箱过满或内存不够，请清理收件箱后重启手机':
    'The inbox may be full or the storage is insufficient. Please clear the inbox and restart your mobile phone.',
  暂无登录密码: 'No login password yet',
  '2、请提交由医疗机构3个月内开具的，有效期内的在职证明，确保姓名、身份证号、医师职称、所在科室、入职时间和公章等信息清晰可见。':
    '2. Please submit an employment certificate issued by a medical institution within 3 months, and ensure that the name, ID number, physician title, department, employment date, and official seal are clearly visible.',
  测试失败: 'Test failed',
  请输入企业标识: 'Enter enterprise logo',
  未知错误: 'Unknown error',
  确认授权: 'Confirm Authorization',
  认证过期: 'Verification expired',
  确认邮箱: 'Confirm email',
  '如"XX医院药师"': 'For example, Pharmacist of a specified hospital.',
  至: 'to',
  软件工程师: 'Software Engineer',
  '更新失败，请稍后重试': 'Update failed. Please try again later.',
  '{name} 请求登录您的腾讯统一身份': '{name} Requests to Log In to Your Tencent OneID Account',
  验证码: 'Verification Code',
  '如：XX公司法人': 'For example, Legal Person of a specified company.',
  授权: 'Authorize',
  您的手机号关联了多个微信账号: 'Your mobile number is associated with multiple WeChat accounts.',
  请输入注册地址: 'Enter registered address',
  请输入邀请码: 'Enter invitation code',
  输入邀请码: 'Enter Invitation Code',
  职称证明: 'Professional Title Certificate',
  确认解绑: 'Confirm Unbind',
  '如"XX公司证券经纪人"': 'For example, Securities Broker of a specified company.',
  '如"证券经纪人"': 'For example, Securities Broker.',
  '{label}官网': '{label} Official Website',
  企微名片下载指引: 'WeCom Business Card Guide',
  '如：XX公司CTO': 'For example, CTO of a specified company.',
  确认取消授权: 'Confirm Cancel Authorization',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位需为基金经理。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The position must be Fund Manager.",
  在职证明和公司营业执照: 'Employment Certificate and Company Business License',
  邮箱验证: 'Email Verification',
  授权电子营业执照: 'Authorize Electronic Business License',
  设置新密码: 'Set',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位需为基金经理。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed. The position must be Fund Manager.",
  您已拒绝使用邮箱登录: 'You have declined to log in with the email',
  '{email} 接收邮箱验证码': '{email} receives the email verification code',
  '密码长度必须在 {minLength}～{maxLength} 位':
    'The password length must be between {minLength} and {maxLength} characters.',
  填写申请人信息: 'Fill in the applicant information.',
  立即授权: 'Authorize Now',
  '更改密码成功，请重新登录': 'Password changed successfully. Please log in again.',
  '修改认证并提交后将重新进入审核状态，通过后修改的信息将替换原有信息。':
    'After modifying and submitting the verification, it will re-enter the review process. Once approved, the modified information will replace the original information.',
  确认将此邮箱设置为默认登录邮箱: 'Set this email as the default login email',
  '请输入新的密码。更改后，原密码将无法登录。':
    'Enter new password. After change, old password will no longer work.',
  '请联系管理员为当前企业开通{appName}':
    'Please contact the admin to activate {appName} for the current enterprise.',
  '如"法人"': 'For example, Legal Person.',
  请联系管理员为您分配应用许可: 'Please contact the admin to assign an app license to you.',
  添加个人认证头像: 'Add Personal Verification Avatar',
  手机: 'Mobile Phone',
  '请输入新的密码，修改后，原密码将无法登录':
    'Enter new password. After change, old password will no longer work.',
  '请联系管理员为您重新启用。您也可选择以下企业登录{appName}。':
    'Please contact the admin to re-enable your account. You can also select one of the following enterprises to log in to {appName}.',
  产品: 'Product',
  '如"就业咨询顾问"': 'For example, Career Consultant.',
  请确认密码: 'Please confirm the password.',
  手机号不能为空: 'The mobile number cannot be empty',
  '1、请提交由公办、民办学校开具的，3个月内开具的在职证明，确保姓名、身份证号、学校名称、职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '1. Please submit an employment certificate issued by a public or private school within 3 months, and ensure that the name, ID number, school name, position, employment date, and official seal are clearly visible and unobstructed.',
  '绑定后，您可以使用您的账号登录到当前企业':
    'After binding, you can use your account to log in to the current enterprise.',
  '{type}解除绑定失败': 'Failed to unbind {type}.',
  请再次输入密码: 'Enter password again',
  账号管理中心: 'Account Management Center',
  '验证“': 'Verify',
  暂无可切换企业账号: 'No enterprise accounts available to switch',
  请输入正确的手机号: 'Enter a valid mobile number',
  '执业资格证、登记备案截图、劳动合同':
    'Professional Qualification Certificate, Registration Screenshot, and Employment Contract',
  '您在当前企业已被停用，请联系管理员':
    'Your account in the current enterprise has been disabled. Please contact the admin.',
  '创建{orgName}': 'Create {orgName}',
  '请联系管理员为您加入当前企业或登录其他账号。':
    'Please contact the admin to add you to the current enterprise or log in with another account.',
  企业微信已绑定: 'WeCom has been bound.',
  '1、请提交中国期货业协会官网信息公示中个人资质截图，需清晰展示"姓名"、"执业机构"、"任职部门"和"从业资格证号"等信息，链接：https://gs.amac.org.cn/。':
    '1. Please submit a screenshot of your personal qualification from the website of the China Futures Association, clearly showing the name, practicing institution, department, and practitioner qualification number. Link: https://gs.amac.org.cn/.',
  登录其他账号: 'Log In with Another Account',
  '1、请提交中国营养学会颁发的有效期内的注册营养师/注册营养技师资格，确保清晰、完整展示所有信息。':
    '1. Please submit a valid registered dietitian/registered nutrition technician qualification certificate issued by the Chinese Nutrition Society, and ensure that all information is clearly and completely displayed.',
  请确保站外平台的昵称与认证昵称一致:
    'Please ensure that the nickname on the external platform matches your verification nickname.',
  '此{type}账号已被绑定': 'This {type} account is already bound.',
  请设置邮箱密码: 'Please set an email password.',
  '请提交由人社或教育部门颁发的教师职称证明，确保姓名、任职资格、任职学校和 公章 等信息清晰可见、无遮挡。如证明缺少学校等信息，请在补充材料中提交在职证明/劳务合同/教师证等能够证明在职学校等证明材料。':
    'Please submit a teacher professional title certificate issued by the Ministry of Human Resources and Social Security or education authorities, and ensure that the name, qualification, school, and official seal are clearly visible and unobstructed. If the certificate lacks school information, please submit additional materials such as an employment certificate, employment contract, or teacher ID card to verify your school.',
  咨询: 'Consulting',
  认证成功: 'Verification successful',
  图片已上传: 'Image uploaded',
  '授权后，腾讯会议将获得您的以下信息用于对外展示：企业/组织标识和简称、企业认证信息、企业认证状态发生的变更。':
    'After authorization, Tencent Meeting will obtain the following information for external display: enterprise/organization logo and abbreviation, enterprise verification information, and changes to enterprise verification status.',
  微信扫码完成人脸录入: 'Scan the QR code via WeChat to complete the facial registration.',
  密码: 'Password',
  '该账号已被停用，请联系管理员': 'The account has been disabled. Please contact the admin.',
  基金经理: 'Fund Manager',
  '换绑完成后，您可以使用新账号所绑定的手机号或微信登录该企业，当前账号将无法再登录该企业':
    'After rebinding, you can use the mobile number or WeChat account bound to the new account to log in to the enterprise. The current account will no longer be able to log in to the enterprise.',
  提供账号服务: 'provides account services',
  请填写申请人姓名: 'Enter applicant name',
  请先同意服务协议和隐私政策: 'Please agree to the Service Agreement and Privacy Policy first.',
  从业资格证和劳动合同: 'Practitioner Qualification Certificate and Employment Contract',
  上传认证资料: 'Upload Verification Materials',
  '请提交包括但不限于高校官网个人主页链接及截图、"聘书"、"资格证书"等能够证明在职学校、职称以及其他认证信息的证明材料。':
    'Please submit supporting materials including but not limited to your university website personal page link and screenshot, appointment letter, or qualification certificate that can prove your school, professional title, and other certification information.',
  '手机号被他人注册？': 'Mobile number registered by someone else? ',
  '未有可用的认证源，请联系管理员配置':
    'No available identity provider. Please contact the admin to configure it.',
  已绑定: 'Bound',
  正在处理: 'Processing',
  和: 'and',
  '修改手机号后，请重新获取验证码':
    'After changing the mobile number, please resend the verification code.',
  '您的登录用户名：': 'Your login username: ',
  注册营养师资格和在职证明: 'Registered Dietitian Qualification and Employment Certificate',
  找回密码: 'Retrieve Password',
  请输入新密码: 'Enter new password',
  其他登录方式: 'Other Login Methods',
  姓名不可超过64字符: 'The name cannot exceed 64 characters',
  教育机构培训人员: 'Education Institution Trainer',
  '如"XX公司证券投资经理"': 'For example, Securities Investment Manager of a specified company.',
  授权失败: 'Authorization failed',
  '如"CEO"': 'For example, CEO.',
  '如"XX公司开发工程师"': 'For example, Development Engineer of a specified company.',
  申请解绑: 'Apply to Unbind',
  证明材料类型: 'Supporting Material Type',
  '文件{name}格式不支持，请重新选择':
    'The format of file {name} is not supported. Please re-select.',
  录入成功: 'Entry successful',
  '腾讯会议将获得您的以下信息用于对外展示：认证头像和名称、职业/达人认证信息、认证状态变更。':
    'Tencent Meeting will obtain the following information for external display: verification avatar and name, professional or KOL verification information, and verification status changes.',
  '请提交包括但不限于"在职证明"、"劳务合同"等能够证明在职公司、目前职位、在职时效以及其他认证信息的证明材料。':
    'Please submit supporting materials that can verify your current employer, position, employment period, and other verification information, including but not limited to an employment certificate and employment contract.',
  游戏达人: 'Gaming KOL',
  '2、请提交在在国家金融监督管理局备案的保险机构或保险中介机构任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡':
    '2. Please submit an employment contract with a remaining term of more than 6 months from an insurance institution or intermediary registered with the National Financial Regulatory Administration, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  记住我: 'Remember me',
  必须上传身份证正反面: 'Both front and back of ID card must be uploaded',
  请输入发证地址: 'Enter certificate issuing address',
  已拒绝企业邀请: 'Enterprise invitation declined',
  收不到验证码说明: 'Instructions for not receiving verification codes',
  姓名不能超过80个字符: 'The name cannot exceed 80 characters',
  '如"人事"': 'For example, HR.',
  '检查名片是否包含企业简称、姓名、职务、手机和邮箱。若未包含可点击 ① “编辑图标”修改，若已包含可直接 ② 保存。':
    'Check whether the business card contains the enterprise abbreviation, name, job title, mobile phone, and email. If no, tap ① the editing icon to edit; if yes, tap ② to save.',
  请您先完成电子营业执照信息授权:
    'Please complete the electronic business license authorization first',
  万元: '0,000 CNY',
  您对名称所做的修改会反映在您的个人版账号中:
    'Changes to the name will be reflected in your personal edition account.',
  认证失败: 'Verification failed',
  '未检测到匹配用户，登录失败！有问题请联系企业管理员。':
    'No matching user detected. Login failed. Please contact the enterprise admin.',
  娱乐达人: 'Entertainment KOL',
  管理员: 'Admin',
  '进行企业认证，': 'for enterprise verification.',
  使用其他账号登录: 'Use Another Account to Log In',
  确认手机号: 'Confirm mobile number',
  从业资格证和在职证明: 'Practitioner Qualification Certificate and Employment Certificate',
  认证方式: 'Verification Method',
  '为了您的资产安全，请先验证您的身份。':
    'For the security of your assets, please verify your identity first.',
  创建人姓名不能超过60个字符: 'The creator name cannot exceed 60 characters',
  换绑成功: 'Rebinding successful',
  开始日期: 'Start Date',
  '如：XX公司总经理': 'For example, General Manager of a specified company.',
  '请输入{text}': 'Enter {text}',
  '您暂未设置密码，为了您的账号安全，请重置密码':
    'You have not set a password yet. For your account security, please reset your password.',
  去登录: 'Log In',
  '请联系管理员为当前企业开通{appName}，或登录其他账号。':
    'Please contact the admin to activate {appName} for the current enterprise, or log in with another account.',
  劳务合同和事业单位法人证明: 'Employment Contract and Public Institution Legal Person Certificate',
  设计师: 'Designer',
  当前登录企业: 'Current Login Enterprise',
  必填内容为空: 'The required field is empty',
  '移动端暂不支持设置，请在桌面端操作':
    'This setting is not supported on the mobile terminal yet. Please use the desktop terminal.',
  登录失败: 'Login failed',
  律师执业证: 'Lawyer Practice License',
  非企业组织授权函认证: 'Non-Enterprise Organization Authorization Letter Verification',
  请输入申请人手机号: 'Enter applicant mobile number',
  职位: 'Position',
  '2、请提交有效期内公司营业执照，需盖有公章，确保所有信息清晰可见、无遮挡。':
    '2. Please submit a valid company business license stamped with the official seal, and ensure that all information is clearly visible and unobstructed.',
  从业人员资质截图和在职证明: 'Practitioner Qualification Screenshot and Employment Certificate',
  基金投资经理: 'Fund Investment Manager',
  '1、请提交由相关医院或技术资格评审会颁发的药师职称证明，需盖有公章，并清晰展示"姓名"、"专业方向"、"资格名称"和"证书编号"等相关信息。':
    '1. Please submit a pharmacist professional title certificate issued by the relevant hospital or technical qualification review committee, stamped with the official seal, clearly showing the name, specialty, qualification name, and certificate number.',
  '对不起，您的认证已失效，失效原因：{reason}，可选择重新发起认证。':
    'Sorry, your verification is no longer valid. Reason: {reason}. You can re-initiate verification.',
  '1、请提交由公办、民办学校开具的，结束时间大于半年的劳务合同，确保姓名、身份证号、学校名称、职位、入职时间 和 公章 等信息清晰可见、无遮挡':
    '1. Please submit an employment contract with a remaining term of more than 6 months issued by a public or private school, and ensure that the name, ID number, school name, position, employment date, and official seal are clearly visible and unobstructed.',
  '如"XX医院内科医生"': 'For example, Internal Medicine Doctor of a specified hospital.',
  请填写开始日期: 'Enter start date',
  '2、请提交3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    '2. Please submit an employment certificate issued within 3 months, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.',
  不再提醒: 'Do Not Remind Again',
  '如"语文老师"': 'For example, Chinese teacher.',
  组织机构认证: 'Organization Verification',
  选择验证方式: 'Select Method',
  欢迎使用身份认证: 'Welcome to Identity Verification',
  认证材料: 'Verification Materials',
  '补充头像、昵称与认证身份后，即可预览':
    'You can add an avatar, nickname and verification identity to enable the preview.',
  企业登录方式: 'Enterprise Login Method',
  认证类型: 'Verification Type',
  '确定要恢复到系统默认的图片吗？': 'Are you sure you want to restore the system default image?',
  请选择登录方式: 'Select Login Method',
  您所处地区信号不好或接收短信时手机处于关机状态:
    'The signal in your area may be poor, or your mobile phone may have been powered off when the SMS was sent.',
  授权管理: 'Authorization Management',
  请输入签发机关: 'Enter issuing authority',
  '如"药师"': 'For example, Pharmacist.',
  请设置登录密码: 'Please set a login password.',
  个人版: 'Personal Edition',
  适合企业微信的用户: 'For WeCom users',
  专业资质证明: 'Professional Qualification Proof',
  必须包含数字: 'Must contain digits.',
  '请联系管理员为您加入当前企业。或登录其他账号。':
    'Please contact the admin to add you to the current enterprise or log in with another account.',
  是否确认授权: 'Are you sure you want to authorize?',
  请输入有效的企业域名: 'Enter a valid enterprise domain',
  '将向您在企业内登记的邮箱/手机号发送验证码，如未登记邮箱/手机号，请联系企业管理员重置密码。':
    'A verification code will be sent to the email/mobile number registered in your enterprise. If no email/mobile number is registered, please contact your enterprise admin to reset your password.',
  新密码: 'New Password',
  '对不起，您的认证已失效，可选择重新发起认证。':
    'Sorry, your verification is no longer valid. You can re-initiate verification.',
  请输入您的企业邮箱: 'Enter your enterprise email',
  在职证明和事业单位法人证明:
    'Employment Certificate and Public Institution Legal Person Certificate',
  '如"XX高校语文老师"': 'For example, Chinese teacher of a specified university.',
  '如：XX公司人事': 'For example, HR of a specified company.',
  '人员创建失败！有问题请联系企业管理员。':
    'Failed to create the user. Please contact the enterprise admin.',
  取消授权成功: 'Authorization canceled successfully',
  监管系统截图和在职证明: 'Regulatory System Screenshot and Employment Certificate',
  '链接已失效， 请重新进入': 'The link has expired. Please re-enter.',
  请确保站外平台的身份与认证身份一致:
    'Please ensure that the identity on the external platform matches your verification identity.',
  '{type}已解除绑定': '{type} has been unbound.',
  已绑定手机号: 'Bound Mobile Number',
  '已有账号？': 'Already have an account? ',
  查看申请资料: 'View Application Materials',
  发证机关: 'Issuing Authority',
  下载模板: 'Download Template',
  用户行为日志: 'User behavior logs',
  法律: 'Law',
  '选择后，企业将自动开通{appName}。':
    'After selection, {appName} will be automatically activated for the enterprise.',
  媒体报道链接: 'Media Coverage Link',
  '如"XX电台前线记者"': 'For example, Frontline Reporter of a specified station.',
  前往登录: 'Go to Log In',
  发送验证码: 'Send Verification Code',
  证券从业人员: 'Securities Practitioner',
  '请输入{label}': 'Enter {label}',
  请绑定手机号并验证身份: 'Please bind your mobile number and verify your identity.',
  '密码设置成功，请重新登录': 'Password set successfully. Please log in again.',
  '如"营养师"': 'For example, Nutritionist.',
  确认手机号成功: 'Mobile number confirmed',
  '如"XX公司金融分析师"': 'For example, Financial Analyst of a specified company.',
  '撤回认证后将无法恢复，如需继续认证，可重新提交认证申请。':
    'The withdrawal cannot be undone. To continue the verification, you can resubmit an application.',
  请填写有效日期: 'Enter a valid date',
  个人材料认证: 'Personal Material Verification',
  解除绑定: 'Unbind',
  '管理员更新了密码策略，请重置密码':
    'The admin has updated the password policy. Please reset your password.',
  '检测到多个匹配用户，登录失败！有问题请联系企业管理员。':
    'Multiple matching users detected. Login failed. Please contact the enterprise admin.',
  '请提交有效期内的由电视台、报社等媒体机构出示的全职在职证明/劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。其中在职证明需在3个月内开具，劳务合同有效期需大于半年。':
    'Please submit a valid full-time employment certificate or employment contract issued by a TV station, newspaper, or other media institutions, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The employment certificate must be issued within 3 months, and the employment contract must have a remaining term of more than 6 months.',
  营业期限: 'Business Period',
  加入: 'Join',
  配置教程: 'Configuration Guide',
  您也可以联系管理员为您开通权限: 'You can also contact the admin to grant you access.',
  邮箱换绑成功: 'Email rebinding successful',
  '邀请码错误，请检查后重新输入': 'The invitation code is incorrect. Please check and re-enter.',
  '{phone} 接收短信验证码': '{phone} receives the verification code',
  '{orgName}名称最多输入60个字符': 'The {orgName} name can contain up to 60 characters',
  '请提交有效期内公司营业执照或事业单位法人证明，需盖有公章，确保所有信息清晰可见、无遮挡。':
    'Please submit a valid company business license or public institution legal person certificate stamped with the official seal, and ensure that all information is clearly visible and unobstructed.',
  '为了您的资产安全，请先完成手机号绑定。':
    'For the security of your assets, please complete the mobile number binding first.',
  重新授权: 'Re-authorize',
  身份核验: 'Identity Check',
  '金融/财经': 'Finance',
  '如"XX公司舞美"': 'For example, Stage Designer of a specified company.',
  '如"内科医生"': 'For example, Internal Medicine Doctor.',
  请选择证明材料类型: 'Please select a supporting material type',
  请输入新的名称: 'Enter a new name',
  手机号登录: 'Mobile Number Login',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed.",
  '《使用手册》': 'User Manual',
  隐私政策: 'Privacy Policy',
  适合已站外认证的用户: 'For users already verified on external platforms',
  申请人手机号: 'Applicant Mobile Number',
  验证: 'Verify',
  设置登录密码: 'Set Login Password',
  '如"XX公司演员"': 'For example, Actor of a specified company.',
  用户已停用: 'The user has been disabled.',
  '暂未选择{authTypeName}': 'No {authTypeName} selected',
  上传图片: 'Upload Image',
  心理咨询师: 'Psychological Counselor',
  '该{label}简称已存在，请重新输入':
    'The {label} abbreviation already exists. Please enter a different one.',
  企微名片认证: 'WeCom Business Card Verification',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位需为基金投资经理。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed. The position must be Fund Investment Manager.",
  '国家二级/三级心理咨询师证': 'National Level-2/Level-3 Psychological Counselor Certificate',
  微信: 'WeChat',
  律师: 'Lawyer',
  请获取验证码: 'Please send the verification code',
  职业认证: 'Professional Verification',
  '该手机号在“{name}”下账号已被封禁，请联系管理员':
    'The account under {name} for this mobile number has been blocked. Please contact the admin.',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券投资咨询(投资顾问)。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed. The position is Securities Investment Advisory (Investment Advisor).",
  ocr识别错误请重新上传: 'OCR failed. Please upload again',
  请输入正确的链接: 'Enter a valid URL',
  '{prefix}用户名': '{prefix} username',
  医疗健康: 'Healthcare',
  统一社会信用代码不能为空: 'The unified social credit code cannot be empty',
  '2、请提交有效期内事业单位法人证明，需盖有公章，确保所有信息清晰可见、无遮挡。':
    '2. Please submit a valid public institution legal person certificate stamped with the official seal, and ensure that all information is clearly visible and unobstructed.',
  '选择后，企业将自动开通应用。':
    'After selection, the app will be automatically enabled for the enterprise.',
  获取验证码: 'Send Verification Code',
  重置登录密码: 'Reset Login Password',
  '请输入{label}简称': 'Enter {label} abbreviation',
  '失败原因：{errMsg}': 'Failure reason: {errMsg}',
  '如"XX小学中级教师"': 'For example, Intermediate Teacher of a specified primary school.',
  站外账号链接: 'External Account Link',
  '本账号的租户ID：': 'Tenant ID of this account: ',
  '获取您的姓名、头像': 'Access your name and avatar',
  '如：XX公司总监': 'For example, Director of a specified company.',
  业务范围: 'Business Scope',
  填写认证材料: 'Fill in verification materials.',
  '请上传{materialLabel}': 'Please upload {materialLabel}',
  再次申请: 'Apply Again',
  '若您长时间未关机，请尝试关机重启':
    'If you have not turned off your mobile phone for a long time, please try restarting it.',
  '为了您的账号安全，请先输入旧密码进行验证':
    'For your account security, please enter your old password for verification first.',
  邀请您加入: 'invites you to join',
  '请输入您已完成职业认证的站外账号链接，如微博账号':
    'Enter link to your external account that has completed professional verification (for example, Weibo account)',
  二级以上公共营养师资格和劳动合同:
    'Public Nutritionist Qualification and Employment Contract (Level 2 or Higher)',
  '如"XX公司保险销售经理"': 'For example, Insurance Sales Manager of a specified company.',
  '请输入法定代表/负责人': 'Enter legal representative/person in charge',
  企业域名登录: 'Enterprise Domain',
  房地产: 'Real Estate',
  名称: 'Name',
  无: 'None',
  '如"高级会计师"': 'For example, Senior Accountant.',
  是否为法人: 'Legal Person or Not',
  '申请授权使用您的认证信息，授权后，认证信息将同步至应用中。':
    'requests authorization to use your verification information. Once authorized, the verification information will be synchronized to the app.',
  达人认证: 'KOL Verification',
  验证身份后加入: 'Verify Identity and Join',
  '2、请提交在中国证监会合法机构名录中单位任职的，结束时间大于半年的劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券经纪人。':
    "2. Please submit an employment contract with a company listed in the China Securities Regulatory Commission's directory, with a remaining term of more than 6 months. Ensure that the name, ID number, company name, position, date of employment, and official seal are clearly visible and unobstructed. The position is Securities Broker.",
  文件不存在: 'The file does not exist.',
  请再次输入新密码: 'Enter new password again',
  请填写证件号码: 'Enter ID number',
  创建: 'Create',
  其他证明材料: 'Other Supporting Materials',
  未配置登录方式: 'No login method configured',
  '请输入{orgName}名称': 'Enter {orgName} name',
  企微名片: 'WeCom Business Card',
  请先输入新的名称: 'Enter a new name first',
  微信扫码授权: 'Scan the QR code via WeChat to authorize.',
  总监: 'Director',
  '您可以新建个人账号或使用其他账号登录：':
    'You can create a personal account or log in with another account: ',
  请输入邮箱: 'Enter email',
  重新认证: 'Verify Again',
  更改手机号: 'Change Mobile Number',
  主部门: 'Primary Department',
  请输入业务范围: 'Enter business scope',
  '请选择清晰的扫描件或照片，请保障图片内容无遮挡或过曝，生成的信息更准确。':
    'Please select a clear scan or photo and ensure that the image content is not obscured or overexposed for more accurate results.',
  '请提交包括但不限于"在职证明"、"劳务合同"、"教师工作证"等能够证明在职学校、职位以及其他认证信息的证明材料。':
    'Please submit supporting materials that can verify your school, position, and other verification information, including but not limited to an employment certificate, employment contract, and teacher ID card.',
  请输入媒体报道链接: 'Enter media coverage link',
  '如"基金从业人员"': 'For example, Fund Practitioner.',
  '该手机号在“{name}”下无账号，请更换手机号后再试':
    'No account under {name} is associated with this mobile number. Please try another mobile number.',
  '密码找回成功，请继续登录': 'Password recovered. Please continue to log in.',
  收起: 'Collapse',
  名称不能为空: 'The name cannot be empty',
  '1、请提交由中国证券业协会颁布的有效期内的证券从业资格证 （SAC），需盖有公章，并清晰展示"姓名"、"身份证号"和"证书号码"等相关信息。':
    '1. Please submit a valid Securities Practitioner Qualification Certificate issued by the Securities Association of China, stamped with the official seal, clearly showing the name, ID number, and certificate number.',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券投资咨询(投资顾问)。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The position is Securities Investment Advisory (Investment Advisor).",
  '请提交由人社或教育部门颁发的教师职称证明，确保姓名、任职资格、任职学校和 公章 等信息清晰可见、无遮挡。':
    'Please submit a teacher professional title certificate issued by the Ministry of Human Resources and Social Security or education authorities, and ensure that the name, qualification, school, and official seal are clearly visible and unobstructed.',
  企业和职称: 'Company and Professional Title',
  '{fields}未识别，请重新上传': '{fields} not recognized. Please upload again',
  密码更改失败: 'Failed to change the password.',
  '获取用户信息失败！有问题请联系企业管理员。':
    'Failed to obtain user information. Please contact the enterprise admin.',
  '如"期货从业人员"': 'For example, Futures Practitioner.',
  '如"XX小学语文老师"': 'For example, Chinese teacher of a specified primary school.',
  营业执照: 'Business License',
  密码修改失败: 'Failed to change the password.',
  请发送验证码: 'Please send the verification code',
  '如"XX公司心理咨询师"': 'For example, Psychological Counselor of a specified company.',
  两次输入的密码需要相同: 'The two passwords must match',
  '对不起，您的认证审核未通过，未通过原因：{reason}，您可选择重新发起认证。':
    'Sorry, your verification review is not approved. Reason: {reason}. You can re-initiate verification.',
  两次密码不一致: 'The two passwords do not match.',
  请输入成立日期: 'Enter date of establishment',
  知识达人: 'Knowledge KOL',
  '注：若职称证明中没有体现所需认证的企业信息，请在补充材料中上传例如"在职证明"、"劳务合同"或"聘书"等证明材料。':
    'Note: If the professional title certificate does not include the required enterprise information, please upload additional materials such as an employment certificate, employment contract, or appointment letter.',
  展开: 'Expand',
  设置: 'Settings',
  立即验证: 'Verify Now',
  请输入密码: 'Enter password',
  注册会计师证明和在职证明: 'CPA Certificate and Employment Certificate',
  手机号已被修改: 'The mobile number has been changed',
  当前密码输入错误: 'The current password is incorrect.',
  使用其他手机号: 'Use Another Mobile Number',
  '您正在解绑登录邮箱，请先完成身份验证':
    'You are unbinding the login email. Please complete the identity verification first.',
  我的企业名片: 'My Enterprise Business Card',
  电子执照和在职证明: 'Electronic License and Employment Certificate',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。职位为证券投资咨询(分析师)。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The position is Securities Investment Advisory (Analyst).",
  同意: 'Agree',
  认证源: 'Identity Provider',
  确认将此手机号设置为默认登录手机号: 'Set this mobile number as the default login mobile number',
  其他达人: 'Other KOLs',
  '3、请提交由医疗机构3个月内开具的，有效期内的在职证明，确保姓名、身份证号、医师职称、所在科室、入职时间和公章等信息清晰可见。':
    '3. Please submit an employment certificate issued by a medical institution within 3 months, and ensure that the name, ID number, physician title, department, employment date, and official seal are clearly visible.',
  请完成人脸核验: 'Please complete the facial verification',
  加入失败: 'Joining failed',
  财经作家: 'Financial Writer',
  确认: 'Confirm',
  企业认证: 'Enterprise Verification',
  再次输入密码: 'Enter password again',
  适合所有用户: 'For all users',
  '用户不存在，请联系管理员': 'The user does not exist. Please contact the admin.',
  '检查您的配置再试。': 'Check your configuration and try again.',
  您在当前企业中已被停用: 'You have been disabled in the current enterprise.',
  '{type}绑定成功': '{type} bound successfully',
  '验证码错误次数过多，请稍后再试':
    'Too many incorrect verification code attempts. Please try again later.',
  '验证码格式不正确，不能包含中文字符':
    'Incorrect verification code format. Chinese characters are not allowed.',
  请为您的新邮箱设置登录密码: 'Please set a login password for your new email.',
  短信验证码: 'SMS Verification Code',
  '网络异常，请刷新后重试': 'Network error. Please refresh and try again',
  '，即为“{nameTip}”。': 'i.e., {nameTip}.',
  再次输入新密码: 'Enter new password again',
  '您已离开当前登录的企业，登录状态已失效，请您重新登录':
    'You have left the currently logged-in enterprise. Your login session has expired. Please log in again.',
  '如"HRBP"': 'For example, HRBP.',
  我已阅读并同意: 'I have read and agree to',
  '对不起，您的认证审核未通过，您可选择重新发起认证。':
    'Sorry, your verification review is not approved. You can re-initiate verification.',
  上一步: 'Previous',
  扫码失败: 'Scanning failed',
  企业邮箱登录: 'Enterprise Email',
  证券经纪人: 'Securities Broker',
  '您正在换绑登录邮箱，请先完成身份验证':
    'You are rebinding the login email. Please complete the identity verification first.',
  腾讯云认证: 'Tencent Cloud Verification',
  达人类型: 'KOL Category',
  开始认证: 'Start Verification',
  设置密码: 'Set Password',
  '2、请提交由医疗机构3个月内开具的，有效期内的在职证明，确保姓名、身份证号、职称、所在科室、入职时间和公章等信息清晰可见。':
    '2. Please submit an employment certificate issued by a medical institution within 3 months, and ensure that the name, ID number, professional title, department, employment date, and official seal are clearly visible.',
  所属行业: 'Industry',
  证件号码: 'ID Number',
  '如"XX公司基金经理"': 'For example, Fund Manager of a specified company.',
  法定代表人: 'Legal Representative',
  '已授权应用将获得您的以下信息用于对外展示：企业/组织标识和简称、企业认证信息、企业认证状态发生的变更。':
    'Authorized apps will obtain the following information for external display: enterprise or organization logo and abbreviation, enterprise verification information, and changes to enterprise verification status.',
  '如"房产客户经理"': 'For example, Real Estate Account Manager.',
  企业名称: 'Enterprise Name',
  企业官网: 'Enterprise Website',
  选择已创建企业: 'Select Existing Enterprise',
  绑定: 'Bind',
  审核未通过: 'Review not passed',
  '通过“腾讯统一身份”进行认证': 'Verify via Tencent OneID',
  '{userName}（{accountName}）': '{userName} ({accountName})',
  '1、请提交人社部颁发的有效期内的二级公共营养师资格证书，确保清晰、完整展示所有信息。':
    '1. Please submit a valid level-2 public nutritionist qualification certificate issued by the Ministry of Human Resources and Social Security, and ensure that all information is clearly and completely displayed.',
  请选择成立日期: 'Please select the date of establishment',
  '以下为获取到的具体人员信息：': 'The following is the specific user information obtained: ',
  上传组织法人证明: 'Upload Organization Legal Person Proof',
  换绑至其他账号: 'Rebind to Another Account',
  公司全称不能超过128个字符: 'The full company name cannot exceed 128 characters',
  '姓名：': 'Name: ',
  '1、请提交由保险中介监管系统查询出的个人资质截图，需清晰展示"姓名"、执业证编号、登记日期，链接：https://www.insurcloud.com.cn/。':
    '1. Please submit a screenshot of your personal qualification queried from the Insurance Intermediary Regulatory System, clearly showing the name, practice certificate number, and registration date. Link: https://www.insurcloud.com.cn/.',
  '如"XX医院主管药师"': 'For example, Supervising Pharmacist of a specified hospital.',
  手机号已绑定成功: 'Mobile number bound successfully',
  '如：XX公司CEO': 'For example, CEO of a specified company.',
  '如"XX公司作家"': 'For example, Writer of a specified company.',
  '请联系管理员为您加入当前企业。您也可选择以下企业登录{appName}。':
    'Please contact the admin to add you to the current enterprise. You can also select one of the following enterprises to log in to {appName}.',
  '1、请提交由具备办学许可证的合法教育培训机构开具的，有效期内的在职证明/劳务合同，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。其中 在职证明 需在 3个月 内开具，劳务合同有效期需大于半年。':
    '1. Please submit a valid employment certificate or employment contract issued by a legally licensed educational institution, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed. The employment certificate must be issued within 3 months, and the employment contract must have a remaining term of more than 6 months.',
  注册会计师证明和劳务合同: 'CPA Certificate and Employment Contract',
  请输入企业全称: 'Enter full enterprise name',
  '该手机号加入的{appTag}已超出数量上限':
    'The number of {appTag} joined by this mobile number has reached the limit.',
  '如"财经作家"': 'For example, Financial Writer.',
  您暂无当前企业许可: 'You have no license.',
  请检查短信是否被手机安全软件拦截:
    'Please check whether the SMS was blocked by mobile phone security software.',
  企业电子营业执照认证: 'Enterprise Electronic Business License Verification',
  手机号码格式不正确: 'Incorrect mobile number format',
  '正面身份证照片更换失败，图片大小超过限制':
    'Failed to replace the front-side ID card photo because the image size exceeds the limit.',
  作品证明: 'Work Proof',
  我的个人资料: 'My Personal Info',
  '如"心理咨询师"': 'For example, Psychological Counselor.',
  小写字母: 'Lowercase letters',
  '您将以以下身份登录：': 'You will log in as the following identity: ',
  '如"内科主任"': 'For example, Chief of Internal Medicine.',
  昵称最多为15个字: 'The nickname can contain a maximum of 15 characters',
  邮箱登录: 'Email Login',
  腾讯云授权认证: 'Tencent Cloud Authorization Verification',
  确认拒绝: 'Confirm Decline',
  '2、请提交在中国证监会合法机构名录中单位任职的，3个月内开具的在职证明，确保姓名、身份证号、公司名称、公司职位、入职时间 和 公章 等信息清晰可见、无遮挡。':
    "2. Please submit an employment certificate issued within 3 months by a company listed in the China Securities Regulatory Commission's directory, and ensure that the name, ID number, company name, position, employment date, and official seal are clearly visible and unobstructed.",
  打开腾讯元宝: 'Open Tencent Yuanbao',
  '请提交由相关法务部门颁布的有效期内律师执业证，需盖有公章，并清晰展示"姓名"、"执业机构"、"执业证号"、"年度考核备案"等相关信息。':
    'Please submit a valid lawyer practice license issued by the relevant legal authority, stamped with the official seal, clearly showing the name, practicing institution, license number, and annual review record.',
  授权信息上传范例: 'Authorization Letter Upload Example',
  已恢复默认: 'Restored to default',
  请选择认证身份类型: 'Please select an identity verification type',
  我知道了: 'Got It',
  '当前登录身份：{userName}（{accountName}）': 'Current login identity: {userName} ({accountName})',
  企业全称不能超过128个字符: 'The full enterprise name cannot exceed 128 characters',
  请填写有效期限: 'Enter validity period',
  请输入正确的验证码: 'Enter a valid verification code',
  查看指引: 'View Guide',
  企业微信: 'WeCom',
  '为了您的资产安全，请先完成实名信息绑定。':
    'For the security of your assets, please complete the identity verification information binding first.',
  企业简称: 'Enterprise Abbreviation',
  请输入手机号码: 'Enter mobile number',
};
export default idp;
